class TrLoadMore extends HTMLElement {
	selectors = {
		button: '[data-tr-js-load-more-button]',
		item: '[data-tr-js-load-more-item]',
		pagination: '[data-tr-js-load-more]'
	};

	attributes = {
		targetId: 'data-tr-js-load-more-target-id'
	};

	stateClasses = {
		isLoading: 'is-loading'
	};

	connectedCallback() {
		this.buttonElement = this.querySelector(this.selectors.button);
		this.targetId = this.getAttribute(this.attributes.targetId);
		this.targetElement = this.getTargetElement();

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		this.targetElement = this.getTargetElement();
	}

	bindEvents() {
		if (this.buttonElement) {
			this.buttonElement.addEventListener('click', this.onButtonClick);
		}
	}

	onButtonClick = (event) => {
		event.preventDefault();
		this.load();
	};

	onSectionLoad = (event) => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.init();
	};

	async load() {
		if (!this.buttonElement || !this.targetElement || this.classList.contains(this.stateClasses.isLoading))
			return;

		const nextUrl = this.buttonElement.href;

		if (!nextUrl) return;

		this.setLoading(true);

		try {
			const response = await fetch(nextUrl);
			const html = await response.text();
			const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
			const nextTargetElement = parsedHtml.getElementById(this.targetId);
			const nextPaginationElement = parsedHtml.querySelector(this.selectors.pagination);

			if (!nextTargetElement) return;

			this.appendItems(nextTargetElement);
			this.updateUrl(nextUrl);
			this.replacePagination(nextPaginationElement);
		} finally {
			this.setLoading(false);
		}
	}

	appendItems(nextTargetElement) {
		const nextItemElements = Array.from(nextTargetElement.querySelectorAll(this.selectors.item));

		nextItemElements.forEach((itemElement) => {
			this.targetElement.append(itemElement);
		});
	}

	replacePagination(nextPaginationElement) {
		if (nextPaginationElement) {
			this.outerHTML = nextPaginationElement.outerHTML;
			return;
		}

		this.remove();
	}

	updateUrl(nextUrl) {
		const url = new URL(nextUrl, window.location.origin);

		history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
	}

	setLoading(isLoading) {
		this.classList.toggle(this.stateClasses.isLoading, isLoading);
		this.buttonElement.setAttribute('aria-disabled', String(isLoading));
	}

	getTargetElement() {
		if (!this.targetId) return null;

		return document.getElementById(this.targetId);
	}

	destroy() {
		if (this.buttonElement) {
			this.buttonElement.removeEventListener('click', this.onButtonClick);
		}
	}
}

if (!customElements.get('tr-load-more')) {
	customElements.define('tr-load-more', TrLoadMore);
}
